var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelopeOpen1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_884_861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5.99998V6.60404C14.5 7.15586 14.197 7.66313 13.7112 7.92475L9.39284 10.25M1.5 5.99998V6.60404C1.5 7.15586 1.80299 7.66313 2.28885 7.92475L6.60716 10.25M12.5 11.9231L9.39284 10.25M9.39284 10.25L8.71115 9.88293C8.26719 9.64387 7.73281 9.64387 7.28885 9.88293L6.60716 10.25M6.60716 10.25L3.5 11.9231M14.5 13C14.5 13.8284 13.8284 14.5 13 14.5H3C2.17157 14.5 1.5 13.8284 1.5 13L1.5 5.89592C1.5 5.3441 1.80299 4.83683 2.28885 4.57521L7.28885 1.88291C7.73282 1.64385 8.26719 1.64385 8.71115 1.88291L13.7112 4.57521C14.197 4.83683 14.5 5.3441 14.5 5.89592V13Z",
    stroke: "#0F172A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25213 3.63636V8H7.32955V4.51207H7.30398L6.30469 5.13849V4.32031L7.38494 3.63636H8.25213Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_884_861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeOpen1);
export default __webpack_public_path__ + "static/media/envelopeOpen1.27b3dcc87a3658e6978a07d4048afda4.svg";
export { ForwardRef as ReactComponent };